import { FC } from "react";
import {
    Parameter,
    ParameterName,
    ParameterValue,
    ParametersContainer,
    PersonPhoto,
    PersonProfileCardContainer,
    PlayerBgNumber,
    PlayerBgNumberDigit,
    PlayerName,
    PlayerPosition,
    PlayerNumber,
    ControlsContainer,
} from "./styled";
import { CalendarOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { PlayerDto, PlayerPositionGroup } from "../../../types/player";
import { Loader } from "../../../components/Loader";
import { calculateAge, getFormattedDate } from "../../../utils";
import { PlayerNavigationButton } from "./PlayerNavigationButton";
import { Tooltip } from "antd";

interface PlayerMainInfoWidgetProps {
    playerData: PlayerDto | null;
    loading?: boolean;
}

export const PlayerMainInfoWidget: FC<PlayerMainInfoWidgetProps> = ({
    playerData,
    loading,
}) => {
    const isGk = playerData?.positionGroup === PlayerPositionGroup.Goalkeeper;
    const number = playerData?.number ? playerData?.number?.toString() : '';

    let content = <Loader />;

    if (!loading && playerData) {
        const age = calculateAge(playerData.birthDate);

        const parameters = (
            <ParametersContainer>
                {age &&
                    <Tooltip title={
                        <>
                            <CalendarOutlined style={{ marginRight: '8px' }} />{getFormattedDate(new Date(playerData.birthDate))}
                        </>
                    }
                    >
                        <Parameter>
                            <ParameterName>Возраст</ParameterName>
                            <ParameterValue>{age}</ParameterValue>
                        </Parameter>
                    </Tooltip>
                }
                <Parameter>
                    <ParameterName>Матчи</ParameterName>
                    <ParameterValue>{playerData?.stats?.matches}</ParameterValue>
                </Parameter>
                {isGk && <Parameter>
                    <ParameterName>Сухие</ParameterName>
                    <ParameterValue>{playerData?.stats?.cleanSheets}</ParameterValue>
                </Parameter>}
                {!isGk && <Parameter>
                    <ParameterName>Голы</ParameterName>
                    <ParameterValue>{playerData?.stats?.goals}</ParameterValue>
                </Parameter>}
            </ParametersContainer>
        );

        content = (
            <>
                {number && (
                    <PlayerBgNumber>
                        <PlayerBgNumberDigit key={number?.[0]}>{number?.[0]}</PlayerBgNumberDigit>
                        <PlayerBgNumberDigit key={number?.[1]}>{number?.[1]}</PlayerBgNumberDigit>
                    </PlayerBgNumber>
                )}
                {/*playerData?.photo && <PersonPhoto src={playerData?.photo} alt={playerData.name} />*/}
                {playerData?.photo && <img src={playerData?.photo} alt={playerData.name} className="z-10 block max-h-[400px] sm:max-h-full object-bottom object-contain" />}
                <div className="hidden sm:block absolute right-8 top-10">
                    {parameters}
                </div>
                <div className="absolute flex flex-col items-center z-20 left-3 sm:left-4 top-4">
                    <div className="flex flex-row items-start gap-4 sm:gap-6">
                        {number && <div className="text-8xl">
                            {number}
                        </div>}
                        <div className="text-4xl sm:max-w-[120px]">
                            {playerData?.name}
                        </div>
                    </div>
                    <div className="hidden sm:block text-3xl font-[300]">
                        {playerData?.position}
                    </div>
                </div>
                <div className="sm:hidden absolute bottom-0 w-full text-center bg-slate-950 flex flex-col gap-2 z-10 rounded-t-3xl border-t-2 border-t-white border-solid border-0">
                    <div className="w-fit mx-auto px-2 pt-1 pb-0 text-2xl font-bold rounded-b-2xl border-2 border-t-0 border-white border-solid">
                        {playerData?.position}
                    </div>
                    <div className="flex flex-row justify-center ">
                        {parameters}
                    </div>
                </div>
                <ControlsContainer className="z-20">
                    <PlayerNavigationButton
                        direction="prev"
                        playerData={playerData?.prev}
                        icon={<LeftOutlined />}
                    />
                    <PlayerNavigationButton
                        direction="next"
                        playerData={playerData?.next}
                        icon={<RightOutlined />}
                    />
                </ControlsContainer>
            </>
        );

        return (
            <PersonProfileCardContainer className="relative flex flex-col items-center justify-end w-full pb-28 sm:p-0 h-[560px] max-h-[600px] overflow-hidden text-white">
                {content}
            </PersonProfileCardContainer>
        );
    }
}